import { render, staticRenderFns } from "./CrewAlertComponent.vue?vue&type=template&id=effb48f0"
import script from "./CrewAlertComponent.vue?vue&type=script&lang=js"
export * from "./CrewAlertComponent.vue?vue&type=script&lang=js"
import style0 from "./CrewAlertComponent.vue?vue&type=style&index=0&id=effb48f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports